import { render, staticRenderFns } from "./o_kassa_firma.vue?vue&type=template&id=6be55c42&scoped=true&"
import script from "./o_kassa_firma.vue?vue&type=script&lang=js&"
export * from "./o_kassa_firma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be55c42",
  null
  
)

export default component.exports